




















import { Component, Emit, Prop } from 'vue-property-decorator'
import { findIndex, toNumber } from 'lodash'
import { Sticky, DropdownMenu, DropdownItem } from 'vant'
import SearchCategory from '@pages/search/components/common/search_category.vue'
import Screen from '@pages/search/components/common/search_screen.vue'
import { isAndroidApp, divideNum } from '@utils/index'
import { ALLTENANTGOODS, HASALLCATEGORYLIST } from '../../category.config'
import { SuperMixin } from '../../category.mixin'
import { DistrictBean, CategoryBean } from '@pages/search/search-service'
import { getDistrictListByCityCode } from '@pages/home/home-service'

import { namespace } from 'vuex-class'
const categoryModule = namespace('category')

function displayCss(dom: HTMLElement, isTrue: boolean) {
  if (dom) {
    dom.style.display = isTrue ? 'block' : 'none'
  }
}

@Component({
  components: {
    [Sticky.name]: Sticky,
    [DropdownMenu.name]: DropdownMenu,
    [DropdownItem.name]: DropdownItem,
    SearchCategory,
    Screen,
  },
})
export default class TabSelectComponent extends SuperMixin {
  @Prop({ default: 'transparent' }) readonly classifyColor!: string
  @Prop({ default: false }) readonly loading!: boolean
  @Prop({ default: null }) readonly position!: any
  @Prop({ default: () => [] }) readonly categoryList!: string

  tabLat = ALLTENANTGOODS
  tabLatSelectedIndex = 0
  businessCategorySelect: CategoryBean = {}
  districtList = []
  businessDistrictSelect: DistrictBean = { ID: '', NAME: '全城' }
  distanceSort = false
  saleNumSort = false
  storeFavPersonNumSort = false
  scrollY = 0
  isDropDownSelected = false

  @categoryModule.State selfOperatedData!: any

  get noSelfOperated() {
    return !this.selfOperatedData || this.selfOperatedData?.spuList?.length === 0
  }

  get locationVis() {
    return this.position && this.position.lat && this.position.lng
  }

  async created() {
    this.businessCategorySelect = { title: '全部', categoryId: this.categoryIds?.join(',') }
    this.initData()
    this.changeCondition()
  }
  mounted() {
    this.$nextTick(() => {
      const dropItem = document.querySelector('.van-dropdown-item')
      if (dropItem && isAndroidApp()) {
        dropItem.addEventListener('touchmove', this.moveDropItem, false)
      }
    })
  }

  moveDropItem() {
    this.setAndroidDisplayBlock(false)
  }

  setAndroidDisplayBlock(dp: boolean = true) {
    /**
     * hzw安卓滚动穿透问题修复
     */
    const selfOperated = document.querySelector('.hzwAndroid .self-operated') as HTMLElement
    const recoveryLayout = document.querySelector('.hzwAndroid .recovery-layout') as HTMLElement
    displayCss(selfOperated, dp)
    displayCss(recoveryLayout, dp)
  }

  async initData(): Promise<any> {
    this.districtList = await getDistrictListByCityCode()
  }
  /* 打开下拉框前吸顶 */
  openDrop() {
    this.isDropDownSelected = false
    const unionVanList = document.querySelector('#category-union-list') as HTMLElement
    unionVanList.style.minHeight = '100vh'
    this.toTabSticky(1)
  }
  /* 关闭下拉框后恢复原样 */
  closeDrop() {
    if (!this.isDropDownSelected) {
      window.scrollTo(0, this.scrollY)
    }
    const unionVanList = document.querySelector('#category-union-list') as HTMLElement
    unionVanList.style.minHeight = 'auto'
    /* 解决下拉菜单收起的时候不是从顶部收起的问题 */
    const tabSticky: HTMLElement = this.$refs.tabSticky as HTMLElement
    if (this.scrollY <= tabSticky.offsetTop) {
      const vanDropdownItems = document.querySelector('.van-dropdown-menu__bar--opened+div .van-dropdown-item') as HTMLElement
      const styleTop = vanDropdownItems.style.top
      vanDropdownItems.style.top = '0'
      setTimeout(() => {
        vanDropdownItems.style.top = styleTop
      }, 200)
    }
  }

  changeTabLat(index: number) {
    const callback = () => {
      this.$nextTick(() => {
        this.toTabSticky(-1)
      })
    }
    if (this.tabLatSelectedIndex === index) return
    this.tabLatSelectedIndex = index
    this.distanceSort = false
    this.saleNumSort = false
    this.storeFavPersonNumSort = false
    this.changeCondition(callback)
  }

  changeBusinessCategory(value: any) {
    const callback = () => {
      this.$nextTick(() => {
        this.toTabSticky(0)
      })
    }
    this.isDropDownSelected = true
    this.businessCategorySelect = value
    this.changeCondition(callback)
  }

  changeBusinessDistrict(value: any) {
    const callback = () => {
      this.$nextTick(() => {
        this.toTabSticky(0)
      })
    }
    this.isDropDownSelected = true
    this.businessDistrictSelect = value
    this.changeCondition(callback)
  }

  changeDistanceSort() {
    const callback = () => {
      this.$nextTick(() => {
        this.toTabSticky(-1)
      })
    }
    if (this.loading) return
    this.distanceSort = !this.distanceSort
    if (this.distanceSort) {
      this.storeFavPersonNumSort = false
      this.saleNumSort = false
    }
    this.changeCondition(callback)
  }
  changeGoodCommentSort() {
    const callback = () => {
      this.$nextTick(() => {
        this.toTabSticky(-1)
      })
    }
    if (this.loading) return
    this.storeFavPersonNumSort = !this.storeFavPersonNumSort
    if (this.storeFavPersonNumSort) {
      this.distanceSort = false
      this.saleNumSort = false
    }
    this.changeCondition(callback)
  }
  changeSaleSort() {
    const callback = () => {
      this.$nextTick(() => {
        this.toTabSticky(-1)
      })
    }
    if (this.loading) return
    this.saleNumSort = !this.saleNumSort
    if (this.saleNumSort) {
      this.distanceSort = false
      this.storeFavPersonNumSort = false
    }
    this.changeCondition(callback)
  }

  /* 切换条件时避免连续加载多页 */
  /* condition=0,不管当前滚动条位置在哪，始终尝试跳到tab位置 */
  /* condition=1,仅当前滚动条位置在tab上方时，才尝试跳到tab位置 */
  /* condition=-1,仅当前滚动条位置在tab下方时，才尝试跳到tab位置 */
  toTabSticky(condition: number) {
    this.scrollY = window.scrollY
    const tabSticky: HTMLElement = this.$refs.tabSticky as HTMLElement
    if (condition === 0) {
      window.scrollTo(0, tabSticky.offsetTop + 1)
    } else if (condition > 0 && window.scrollY <= tabSticky.offsetTop) {
      window.scrollTo(0, tabSticky.offsetTop + 1)
    } else if (condition < 0 && window.scrollY > tabSticky.offsetTop) {
      window.scrollTo(0, tabSticky.offsetTop + 1)
    }
  }

  @Emit()
  changeCondition(callback?: any) {
    const { categoryId = '' } = this.businessCategorySelect || {}
    const { ID = '' } = this.businessDistrictSelect || {}
    const con = {
      categoryId,
      districtId: ID,
      distanceSort: this.distanceSort,
      storeFavPersonNumSort: this.storeFavPersonNumSort,
      saleNumSort: this.saleNumSort,
      tabCut: this.tabLat[this.tabLatSelectedIndex].value || '',
      callback,
    }
    return con
  }

  beforeDestroy() {
    const dropItem = document.querySelector('.van-dropdown-item')
    if (dropItem && isAndroidApp()) {
      dropItem.removeEventListener('touchmove', this.moveDropItem, false)
    }
  }
}
